const updates = [
  { id: 1, time: '刚刚', tag: '突发', title: '某知名演员被拍到深夜出入私人会所，同行人员身份引猜测', tagColor: 'primary' },
  { id: 2, time: '15分钟前', tag: '更新', title: '昨日婚变事件女方发长文回应，称将通过法律途径维护权益', tagColor: 'accent' },
  { id: 3, time: '28分钟前', tag: '热议', title: '综艺冲突事件完整视频流出，节目组导演道歉声明引争议', tagColor: 'primary' },
  { id: 4, time: '42分钟前', tag: '独家', title: '知情人士爆料某顶流团队内部矛盾升级，多名核心成员欲解约', tagColor: 'accent' },
  { id: 5, time: '1小时前', tag: '追踪', title: '偷税主播案最新进展：税务部门已冻结其名下多处房产', tagColor: 'secondary' },
  { id: 6, time: '1.5小时前', tag: '发酵', title: '男团私联粉丝事件持续升温，品牌方密集宣布暂停合作代言', tagColor: 'primary' },
  { id: 7, time: '2小时前', tag: '深扒', title: '潜规则导演过往作品被扒出多处疑似不当选角内幕', tagColor: 'accent' },
  { id: 8, time: '3小时前', tag: '快讯', title: '海外媒体曝光某流量明星代孕风波，工作室称系恶意造谣', tagColor: 'secondary' },
  { id: 9, time: '4小时前', tag: '汇总', title: '今日黑料吃瓜总结：五大热点事件全梳理，一条都别错过', tagColor: 'primary' },
];

const tagColorClasses: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const dotColorClasses: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            实时快讯
          </h2>
          <span className="flex items-center gap-1.5 text-sm text-accent-600 font-medium whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            LIVE 实时更新
          </span>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-secondary-200/80"></div>

            <div className="space-y-4">
              {updates.map((update) => (
                <div key={update.id} className="relative flex items-start gap-5 pl-12 group cursor-pointer">
                  <div className={`absolute left-[14px] top-2 w-3 h-3 rounded-full border-2 border-background-50 ${dotColorClasses[update.tagColor]}`}></div>
                  <div className="flex-1 min-w-0 bg-background-100 border border-secondary-200/60 rounded-xl p-4 group-hover:border-primary-200/60 transition-colors">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagColorClasses[update.tagColor]}`}>
                        {update.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{update.time}</span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {update.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}